<template>
  <div class="rource-item">
    <div class="item-top">
      <div class="item-left">
        <img class="item-image" :src="detail.icon | filterUrl" />
      </div>
      <div class="item-right">
        <div v-if="roundCount" class="round-count">
          <template v-if="packageCourse"> {{ detail.childCourseCount }}节 </template>
          <template v-else> {{ detail.courseType == 2 ? detail.childCourseCount : detail.maxChildCourseCount }}节 </template>
        </div>
        <div class="right-top">
          <div class="right-top-title">
            <span class="tag" v-if="detail.source == 1">区域</span>
            {{ type == 2 ? detail.name : detail.name }}
          </div>
          <div class="right-top-desc" :style="{ 'justify-content': type == 2 ? 'start' : '' }">
            <template v-if="type == 1">
              <!-- <span>{{detail.count||'--'}}个文件</span>
              <span>{{detail.size||'--'}}</span> -->
            </template>
            <template v-if="type == 2">
              <span class="icon-desc">
                <svg t="1637042125261" style="margin-right: 4px" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3023" width="14" height="14">
                  <path
                    fill="#999"
                    d="M110.933333 352l384 192c4.266667 2.133333 10.666667 4.266667 17.066667 4.266667s10.666667-2.133333 17.066667-4.266667l384-192c12.8-6.4 19.2-19.2 19.2-32s-8.533333-25.6-19.2-32l-384-192c-10.666667-4.266667-21.333333-4.266667-32 0l-384 192c-12.8 6.4-19.2 19.2-19.2 32s6.4 25.6 17.066666 32zM512 168.533333L814.933333 320 512 471.466667 209.066667 320 512 168.533333zM878.933333 672L512 855.466667 145.066667 672c-17.066667-8.533333-38.4-2.133333-49.066667 17.066667-8.533333 17.066667-2.133333 38.4 17.066667 49.066666l384 192c4.266667 2.133333 10.666667 4.266667 17.066666 4.266667s10.666667-2.133333 17.066667-4.266667l384-192c17.066667-8.533333 25.6-29.866667 17.066667-49.066666-12.8-19.2-34.133333-25.6-53.333334-17.066667z"
                    p-id="3024"
                  ></path>
                  <path
                    fill="#999"
                    d="M878.933333 480L512 663.466667 145.066667 480c-17.066667-8.533333-38.4-2.133333-49.066667 17.066667-8.533333 17.066667-2.133333 38.4 17.066667 49.066666l384 192c4.266667 2.133333 10.666667 4.266667 17.066666 4.266667s10.666667-2.133333 17.066667-4.266667l384-192c17.066667-8.533333 25.6-29.866667 17.066667-49.066666-12.8-19.2-34.133333-25.6-53.333334-17.066667z"
                    p-id="3025"
                  ></path>
                </svg>
                <template v-if="packageCourse"> {{ detail.childCourseCount }}节 </template>
                <template v-else> {{ detail.courseType == 2 ? detail.childCourseCount : detail.maxChildCourseCount }}节 </template>
              </span>
              <span style="margin-left: 12px" class="icon-desc">
                <svg t="1637041983071" style="margin-right: 4px" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1229" width="14" height="14">
                  <path
                    fill="#999"
                    d="M512 64c-256 0-460.8 208-460.8 460.8s208 460.8 460.8 460.8 460.8-208 460.8-460.8S768 64 512 64zM512 940.8c-227.2 0-412.8-185.6-412.8-412.8s185.6-412.8 412.8-412.8 412.8 185.6 412.8 412.8S742.4 940.8 512 940.8z"
                    p-id="1230"
                  ></path>
                  <path
                    fill="#999"
                    d="M809.6 544l-278.4 0 0-281.6c0-12.8-9.6-22.4-22.4-22.4-12.8 0-22.4 9.6-22.4 22.4l0 307.2c0 12.8 9.6 22.4 22.4 22.4 0 0 3.2 0 3.2 0l297.6 0c12.8 0 22.4-9.6 22.4-22.4C832 553.6 822.4 544 809.6 544z"
                    p-id="1231"
                  ></path>
                </svg>
                {{ detail.period }}
              </span>
            </template>
          </div>
        </div>
        <div class="right-content">
          <template v-if="type == 1">
            <span>已使用：{{ detail.usedCount || 0 }}份</span>
            <span v-if="!detail.isLimitCount">剩余可用：无限制</span>
            <span v-else>剩余可用：{{ detail.maxCount - detail.usedCount }}份</span>
            <span v-if="!detail.isLimitUsageDate">截止日期：永久使用</span>
            <span v-else>截止日期：{{ detail.uneffectiveDate ? moment(detail.uneffectiveDate).format('YYYY/MM/DD') : '--' }}</span>
          </template>
          <template v-if="type == 2">
            <!-- <span>课程类型：{{ detail.courseType | getCourseType }}</span> -->
            <span style="margin-bottom: 12px">已使用：{{ detail.usedCount || 0 }}次</span>
            <template v-if="!packageCourse">
              <span v-if="!detail.isLimitCount">剩余可用：无限制</span>
              <span v-else>剩余可用：{{ detail.maxCount - detail.usedCount }} 次</span>
            </template>
          </template>
        </div>
      </div>
    </div>
    <div class="item-bottom">
      <div class="description">
        <a-tooltip placement="topLeft">
          <template slot="title">{{ detail.description }}</template>
          {{ detail.description }}
        </a-tooltip>
      </div>
      <template v-if="showAction">
        <div class="bottom-btn" v-if="type == 2">
          <span :class="{ disabledbtn: detail.source==1}" class="action" @click.stop="$emit('edit')">编辑</span>
          <span :class="{ disabledbtn: detail.hasConfig || detail.source==1}" class="action" @click.stop="remove">删除</span>
        </div>
        <div class="bottom-btn" v-if="type == 1 && detail.source != 1">
          <span :class="{ disabledbtn: detail.source==1}" class="action" @click.stop="$emit('edit')">编辑</span>
          <span :class="{ disabledbtn: detail.hasConfig || detail.source==1 }" class="action" @click.stop="remove">删除</span>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
export default {
  name: 'RourceItem',
  filters: {
    getCourseType(val) {
      const types = {
        1: '测评课程',
        2: '训练课程',
        3: '活动课程',
      }
      return types[val]
    },
  },
  props: {
    packageCourse: {
      default: false,
      type: Boolean,
    },
    showAction: {
      default: true,
      type: Boolean,
    },
    roundCount: {
      default: false,
      type: Boolean,
    },
    detail: {
      type: Object,
      default: () => ({}),
    },
    /** 2：课程 */
    type: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      moment,
    }
  },
  methods: {
    remove() {
      if (this.detail.hasConfig) {
        return this.$message.error('课程资源已被使用，无法删除！')
      }
      this.$emit('del')
    },
  },
}
</script>
<style lang="less" scoped>
.rource-item:hover {
  box-shadow: 2px 2px 5px 2px rgba(94, 94, 94, 0.34);
  border-radius: 3px;
  // border: 1px solid #475A68;
  box-sizing: border-box;
}
.rource-item {
  cursor: pointer;
  padding: 12px;
  padding-bottom: 0;
  width: 380px;
  box-sizing: border-box;
  border: 1px solid transparent;
  box-shadow: 0px 0px 3px 0px rgba(94, 94, 94, 0.34);
  border-radius: 3px;
  margin-bottom: 20px;
  overflow: hidden;
  color: #333;

  .item-top {
    display: flex;
    border-bottom: 1px solid #dbdbdb;
    padding-bottom: 10px;
    .right-top-title {
      font-size: 16px;
      font-weight: 500;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 220px;
      padding-bottom: 4px;
    }
    .right-top-desc {
      display: flex;
      color: #808080;
      font-size: 12px;
      justify-content: space-between;
      flex-wrap: wrap;
      // padding-top: 4px;
      box-sizing: border-box;
      .icon-desc {
        display: flex;
        align-items: center;
      }
    }
    .item-left {
      width: 110px;
      height: 110px;
      min-width: 110px;

      .item-image {
        width: 100%;
        height: 100%;
        vertical-align: middle;
        border-radius: 4px;
      }
    }
    .item-right {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding-left: 10px;
      flex-wrap: wrap;
      box-sizing: border-box;
      position: relative;
      .right-content {
        display: flex;
        flex-direction: column;
        font-size: 12px;
        font-weight: 500;
        margin-top: 20px;
      }
    }
  }
  .round-count {
    width: 47px;
    height: 47px;
    border-radius: 50%;
    position: absolute;
    right: 17px;
    bottom: -2px;
    border: 2px solid #1bc2c3;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #1bc2c3;
    font-weight: 500;
    font-size: 14px;
  }

  .item-bottom {
    display: flex;
    justify-content: end;
    align-items: center;
    height: 40px;
    .description {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: pre;
      ::v-deep .ant-tooltip-inner {
        white-space: break-spaces;
        word-break: break-all;
      }
    }
    .bottom-btn {
      width: 126px;
      display: flex;
      justify-content: end;
      .disabledbtn {
        color: #999999 !important;
        border-color: #999 !important;
      }
    }
    .action {
      margin: 0 8px;
      display: inline-block;
      padding: 4px 0;
      //   height: 26px;
      //   line-height: 26px;
      width: 55px;
      font-size: 12px;
      cursor: pointer;
      display: inline-block;
      border-radius: 14px;
      border: 1px solid #cccccc;
      text-align: center;
      font-weight: 700;
    }
    .action:nth-of-type(2) {
      color: #ee4646;
      border: 1px solid #f9b593;
      margin: 0;
    }
  }
}

.tag {
  border: 1px solid #1890ff;
  border-radius: 5px;
  top: 7px;
  color: #1890ff;
  font-size: 12px;
  padding: 1px 3px;
}
</style>
